export default __webpack_public_path__ + "static/media/MSad.7784b12b.svg";